const getRandom = (array) => array[Math.floor(Math.random() * array.length)];

const getTimeOfDay = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'morning';
    if (hour < 17) return 'afternoon';
    return 'evening';
};

const extractLastPR = (historyEntry) => {
    if (!historyEntry || !historyEntry.description) return null;
    const prMatch = historyEntry.description.match(/NIEUW PR GEZET!\s*([^\n]+)/) ||
                    historyEntry.description.match(/(?:PR|Persoonlijk Record).*?(?:op de|voor)\s+([A-Za-z\s]+)/i);
    return prMatch ? prMatch[1].trim() : null;
};

export const getCoachMessage = (user, history, trainingDays) => {
    const safeHistory = Array.isArray(history) ? history : [];
    const now = new Date();

    const dayOfWeek = now.getDay() === 0 ? 6 : now.getDay() - 1;
    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - dayOfWeek);
    startOfWeek.setHours(0, 0, 0, 0);

    const countThisWeek = new Set(
        safeHistory
            .filter(h => new Date(h.date) >= startOfWeek)
            .map(h => new Date(h.date).toDateString())
    ).size;

    const lastWorkout = safeHistory.length > 0 ? safeHistory[0] : null;
    let daysSinceLast = 0;
    if (lastWorkout) {
        const lastDate = new Date(lastWorkout.date);
        daysSinceLast = Math.floor((now - lastDate) / (1000 * 60 * 60 * 24));
    }

    const firstName = user?.name ? user.name.split(' ')[0] : 'topper';
    const focus = user?.training_type?.toLowerCase() || 'crossfit';
    const targetDays = trainingDays || 4;

    if (countThisWeek >= targetDays) {
        const overtimeMsgs = [
            `Target van ${targetDays} dagen behaald, ${firstName}! Rust en voeding maken je sterker. Wil je toch wat doen? Focus dan vandaag op techniek of actief herstel.`,
            `Weekdoel: in the pocket. Je lichaam heeft nu tijd nodig om te compenseren. Een zware WOD is nu niet optimaal, denk aan mobiliteit.`,
            `Je loopt voor op schema! Extra trainen is prima, maar luister naar je gewrichten. Voorkom overtraining.`,
            `Mooi werk, je hebt je inzet voor deze week getoond. Bouw vandaag een rustige zweet-sessie in zonder de max op te zoeken.`,
            `Doel behaald! Als je vandaag toch traint, zie het dan als 'play' en niet als competitie. Hou je hartslag onder controle.`
        ];
        return getRandom(overtimeMsgs);
    }

    if (lastWorkout) {
        const pr = extractLastPR(lastWorkout);
        if (pr && daysSinceLast <= 2) { 
            const prMsgs = [
                `Lekker bezig met dat PR op je ${pr} de vorige keer! Dat is het harde bewijs dat consistentie werkt.`,
                `Nieuw persoonlijk record gezet op de ${pr}! Vandaag gaan we die gains consolideren. Geen ego-lifting vandaag.`,
                `Nog aan het nagenieten van je PR op de ${pr}? Terecht! Laten we die energie vandaag meenemen in je volgende sessie.`,
                `Gefeliciteerd met je recente PR op de ${pr}, ${firstName}. Tijd om de lat weer een klein beetje hoger te leggen.`
            ];
            return getRandom(prMsgs);
        }
    }

    if (countThisWeek === targetDays - 1 && targetDays > 1) {
        const onTrackMsgs = [
            `Nog één knalsessie verwijderd van je weekdoel. Tijd om het af te maken, ${firstName}!`,
            `De finishlijn van je trainingsweek is in zicht. Maak 'm mooi af vandaag.`,
            `Je bent er bijna. Zet nog één keer die focus aan om je target van ${targetDays} dagen aan te tikken.`,
            `Perfect op schema! Let's go, ${firstName}, nog één goede sessie erin rammen.`
        ];
        return getRandom(onTrackMsgs);
    }

    if (daysSinceLast > 7 && targetDays >= 3) {
        const retentionMsgs = [
            `Daar ben je weer, ${firstName}! We beginnen vandaag verstandig om je hartslag weer even te laten wennen.`,
            `Back in the game! De engine houdt er rekening mee dat je er even uit was. Focus vandaag primair op techniek.`,
            `Tijdje niet gezien! Laten we de motor weer roestvrij maken. Forceer niets, voel de beweging.`,
            `Goed dat je er weer bent. Ritme opbouwen is vandaag belangrijker dan stukgaan.`
        ];
        return getRandom(retentionMsgs);
    }

    const time = getTimeOfDay();

    if (focus.includes('shredding')) {
        const shredMsgs = [
            `Elke rep brengt je dichter bij de fysiek die je voor ogen hebt. Focus aan, ${firstName}.`,
            `Consistentie is de absolute sleutel tot Shredding. Tijd om het werk te doen.`,
            `Zwaar trainen, goed eten. De engine heeft de perfecte hypertrofie prikkel voor je klaargezet.`,
            `Beheers het tempo. In Shredding is de kwaliteit van de rep belangrijker dan het gewicht.`
        ];
        return getRandom(shredMsgs);
    }

    if (focus.includes('fitness')) {
        const fitMsgs = [
            `Tijd om spieren af te breken zodat ze sterker terugbouwen. Let's lift, ${firstName}.`,
            `Krachttraining is een marathon, geen sprint. Focus op je mind-muscle connection vandaag.`,
            `De engine heeft een gebalanceerde set voor je klaarstaan. Tijd om wat ijzer te verplaatsen.`,
            `Focus op de excentrische (zakkende) fase vandaag. Daar zitten je resultaten.`
        ];
        return getRandom(fitMsgs);
    }

    if (time === 'morning') {
        const morningMsgs = [
            `Tijd om de dag te breken, ${firstName}. Zet de toon voor de rest van je dag.`,
            `Vroege vogel! De wereld slaapt nog, maar jij bouwt al aan je conditie. Let's go.`,
            `Beste manier om wakker te worden. De engine heeft a mooie WOD voor je ochtend klaarstaan.`,
            `Koffie erin, focus aan. Tijd om het zweet te laten vloeien.`
        ];
        return getRandom(morningMsgs);
    } else if (time === 'afternoon') {
        const afternoonMsgs = [
            `Halverwege de dag. Perfect moment om even compleet uit je hoofd en in je lichaam te zakken.`,
            `Lunch verteerd? Tijd om de verbranding aan te zetten met een goede sessie.`,
            `Breek je (werk)dag met deze sessie. De engine heeft de ideale prikkel voor je berekend.`,
            `Scherp blijven, ${firstName}. Focus op je techniek, ook als je moe begint te worden.`
        ];
        return getRandom(afternoonMsgs);
    } else {
        const eveningMsgs = [
            `De dag zit er bijna op, maar niet voordat jij je werk hebt gedaan. Focus aan, ${firstName}.`,
            `Laatste inspanning van de dag. Laat alle stress van vandaag achter op de vloer.`,
            `De engine heeft een mooie afsluiting van je dag berekend. Gooi de tank leeg.`,
            `Avondsessie! Bouw dat slaaptekort op in je spieren, daar ga je straks heerlijk van rusten.`
        ];
        return getRandom(eveningMsgs);
    }
};

// ✅ HYBRIDE POST-WORKOUT ENGINE (PRIORITEIT OP OPENROUTER AI, DAN FALLBACK)
export const getPostWorkoutInsight = (user, history) => {
    if (!history || history.length === 0) return null;
    const lastWorkout = history[0];
    const lastDate = new Date(lastWorkout.date);
    const today = new Date();
    
    if (lastDate.toDateString() !== today.toDateString()) return null;

    // ✨ 1. HEEFT DE DATABASE EEN ECHTE AI COCH INSIGHT VAN OPENROUTER? PAK DIE!
    if (lastWorkout.ai_insight && lastWorkout.ai_insight.trim() !== "") {
        return lastWorkout.ai_insight;
    }

    // 🎲 2. OFFLINE OF NOG AAN HET LADEN? GEBRUIK DE SLIMME STATISCHE VARIATIE FALLBACK
    const pr = extractLastPR(lastWorkout);
    const type = (lastWorkout.type || 'Workout').toLowerCase();
    const isShredding = user?.training_type?.toLowerCase().includes('shredding');
    const firstName = user?.name ? user.name.split(' ')[0] : 'Sporter';

    if (pr) {
        const prMsgs = [
            `Je hebt alles gegeven vandaag, met een waanzinnig PR op de ${pr} als resultaat! 🔥 Zorg voor extra eiwitten vandaag en pak je slaap. Mocht je morgen weer trainen, vermijd dan zware gewichten op deze spiergroep.`,
            `Nieuw persoonlijk record gezet op de ${pr}, ${firstName}! 🚀 Je zenuwstelsel heeft ongetwijfeld een klap gehad. Tijd om die energietank weer aan te vullen met de juiste voeding. Rust goed uit!`,
            `Die ${pr} ging fantastisch. 🏆 Omdat je maximaal bent gegaan, adviseer ik morgen een lichte herstelsessie, of een focus op mobiliteit en stretchwerk.`
        ];
        return getRandom(prMsgs);
    } 
    
    if (isShredding || type.includes('kracht') || type.includes('shredding')) {
        const strengthMsgs = [
            `Solide sessie, ${firstName}. Je spiervezels hebben precies de juiste prikkel gekregen om te groeien. 🔋 De focus ligt nu 100% op herstel: hydratatie en stevige voeding zijn cruciaal.`,
            `Krachttraining zit erop! 🧱 Je spieren staan nu in de afbreekfase, het opbouwen gebeurt vannacht. Zorg voor minimaal 8 uur slaap en voldoende eiwitten in je volgende maaltijd.`,
            `Lekker volume gedraaid vandaag. 📈 Let vanavond goed op je voeding. Als je morgen weer traint, pakken we een andere spiergroep aan of plannen we actief herstel in.`
        ];
        return getRandom(strengthMsgs);
    } 
    
    if (type.includes('cardio') || type.includes('interval') || type.includes('endurance')) {
        const cardioMsgs = [
            `Lekkere engine-sessie, ${firstName}! Je hartslag heeft flink moeten werken, wat perfect is voor je algehele conditie. 🏃‍♂️ Vul je koolhydraten aan en blijf goed gehydrateerd.`,
            `Conditiewerk zit in de pocket. 🫁 Je hebt je zuurstofopname flink geprikkeld. Morgen ben je waarschijnlijk weer fris genoeg voor het zwaardere lift-werk, mits je vanavond goed eet.`,
            `Stevig tempo vandaag! 💧 Zorg dat je vochtbalans weer op peil komt. Dit is een uitstekende basis voor je uithoudingsvermogen op de lange termijn.`
        ];
        return getRandom(cardioMsgs);
    } 

    const defaultMsgs = [
        `Kapot gemaakt! 🚀 Je hebt een flinke trainingsprikkel afgeleverd. Je lichaam gaat nu direct in de herstelstand. Luister goed naar je energielevel vanavond.`,
        `Weer een WOD afgevinkt, ${firstName}. 👏 Goed gewerkt. Eet goed, slaap diep en kijk morgen hoe je lichaam aanvoelt voordat je weer 100% gas geeft.`,
        `Top inzet vandaag! 🎯 Het werk is gedaan, nu begint de adaptatie. Neem je rust net zo serieus als je training, dan ben je morgen weer klaar voor de volgende ronde.`
    ];
    
    return getRandom(defaultMsgs);
};
